import React from "react"
import { HorizontalStack } from "@mallardbay/lib-react-components"
import type { PaymentMethod } from "@stripe/stripe-js"

import PaymentMethodSelectFormCore from "~components/pages/account/payment-methods/payment-method-select-form-core"
import AddPaymentMethodButton from "~components/pages/account/payment-methods/add-payment-method-button"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import { isPaymentMethodAch } from "~utils/stripe-helpers"
import { type PaymentMethodState } from "~utils/use-payment-method-state"
import useSportsmanPaymentBlocks from "~utils/use-sportsman-payment-blocks"
import { useUser } from "~config/user-provider"

interface Props {
    readonly selectedId: string | null
    readonly onChange: (update: Partial<PaymentMethodState>) => void
    readonly isExternalPaymentMethod?: boolean
    readonly isPayWithCheckEnabled?: boolean
}

export default function PaymentMethodSelectForm({
    selectedId,
    onChange,
    isExternalPaymentMethod,
    isPayWithCheckEnabled,
}: Props) {
    const { user } = useUser()
    const { paymentMethods, isLoading, error, refetch } =
        useSportsmanPaymentBlocks({ sportsmanId: user?.id })

    return (
        <LoadingOrErrorContainer
            isLoading={isLoading}
            error={error}
            shouldRenderChildren
            noMargin
            noPadding
        >
            <PaymentMethodSelectFormCore
                selectedId={selectedId}
                onChange={onChange}
                paymentMethods={paymentMethods}
                isPayWithCheckEnabled={isPayWithCheckEnabled}
                isExternalPaymentMethod={isExternalPaymentMethod}
            />
            <HorizontalStack>
                <AddPaymentMethodButton
                    onPaymentMethodAdded={(paymentMethod: PaymentMethod) => {
                        onChange({
                            paymentMethodId: paymentMethod.id,
                            isAchPaymentMethod:
                                isPaymentMethodAch(paymentMethod),
                            isExternalPaymentMethod: false,
                        })
                        void refetch()
                    }}
                />
            </HorizontalStack>
        </LoadingOrErrorContainer>
    )
}
